import { render } from "./Testimonials.vue?vue&type=template&id=9e7dfdc0&scoped=true"
import script from "./Testimonials.vue?vue&type=script&lang=js"
export * from "./Testimonials.vue?vue&type=script&lang=js"

import "./Testimonials.vue?vue&type=style&index=0&id=9e7dfdc0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e7dfdc0"]])

export default __exports__